import { render, staticRenderFns } from "./bulletinInfo.vue?vue&type=template&id=57d21a73&"
import script from "./bulletinInfo.vue?vue&type=script&lang=js&"
export * from "./bulletinInfo.vue?vue&type=script&lang=js&"
import style0 from "./bulletinInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports